export const BUSINESS_TYPE_ACCOUNTANCY_ID = 'I work in an accountancy firm';
export const BUSINESS_TYPE_BOOKKEEPER_ID = 'I am a bookkeeper';
export const BUSINESS_TYPE_BUSINESS_ID = 'I work in a business';

export const businessTypeOptions = [
  { id: BUSINESS_TYPE_ACCOUNTANCY_ID },
  { id: BUSINESS_TYPE_BOOKKEEPER_ID },
  { id: BUSINESS_TYPE_BUSINESS_ID }
];
